import styles from './Breadcrumb.module.scss';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode | ReactNode[];
}

export function Breadcrumb(props: Props) {
  const className = [styles['breadcrumb']].filter(Boolean).join(' ');
  return (
    <nav>
      <ul className={className}>{props.children}</ul>
    </nav>
  );
}
